/*
 * @Author: lijing 
 * @Date: 2022-08-28 14:49:44 
 * @Last Modified by: lijing
 * @Last Modified time: 2022-09-07 16:21:34
 */
import React, { FC, useEffect, useState } from 'react';
import { Input, Table, Modal, message } from 'antd';
import { selectVideo } from "@root/common/service";
import type { ColumnsType } from 'antd/es/table';


const { Search } = Input;

export interface IVideoProp {
    account: string,
    applyCount: number,
    createBy: string,
    createTime: string,
    deleted: number,
    duration: number,
    durationText: string,
    fileName: string,
    fileType: string,
    id: number,
    imageUrl: string,
    instituteId: number,
    name: string,
    originalSize: number,
    source: number,
    status: number,
    statusText: string,
    subjectId: number,
    thirdCategoryId: string,
    thirdVideoId: string,
    totalSize: number,
    updateTime: string,
    uploadChannel: number,
    uploadChannelText: string,
    uploadTimeText: string,
    uploadUser: number,
}

interface IProps {
    courseSectionIndex: number,
    onSelectVideoCallback: (data: IVideoProp) => void
    setIsCheckVideoVisible: React.Dispatch<React.SetStateAction<boolean>>,
}

export const CheckVideo: FC<IProps> = (props) => {
    const columns: ColumnsType<IVideoProp> = [
        {
            title: '视频名称',
            dataIndex: 'name',
            key: 'name',
            render(text, data) {
                return (
                    <React.Fragment>
                        <img height="70" src={data.imageUrl} />
                        <div>{text}</div>
                        <div>{data.thirdVideoId}</div>
                    </React.Fragment>
                );
            },
        },
        {
            title: '时长',
            dataIndex: 'durationText',
            key: 'durationText',
        },
        {
            title: '状态',
            dataIndex: 'statusText',
            key: 'statusText',
        }
    ];

    const [VideoList, setVideoList] = useState<IVideoProp[]>([]);
    const [tableLoading, setTableLoading] = useState(false);
    const [tableTotal, setTableTotal] = useState(1);
    const [tablePageNum, setTablePageNum] = useState(1);

    const handleOk = () => {
        if (selected === undefined) {
            message.error('请选择视频');
        } else {
            props.onSelectVideoCallback(selected as IVideoProp)
        }
    };

    const handleCancel = () => {
        props.setIsCheckVideoVisible(false);
    };

    const getVideoList = (page = tablePageNum, params?: object) => {
        setTableLoading(true);
        setTablePageNum(page);
        selectVideo(
            { pageNum: page, pageSize: 10 },
            { ...params }
        ).then((res: any) => {
            const { data: { rows, total } } = res;
            setVideoList(rows);
            setTableTotal(total);
        }).finally(() => {
            setTableLoading(false);
        });
    }

    function onSearch(text: string) {
        return getVideoList(1, { name: text });
    }

    let selected: IVideoProp | undefined = undefined;
    function onRadioChange(array: any) {
        const data: IVideoProp | undefined = VideoList.find((item: IVideoProp) => {
            return item.id === array[0];
        });

        selected = data;
    }

    useEffect(() => {
        getVideoList()
    }, [])

    return (
        <Modal
            title="新建课程"
            width={980}
            visible={true}
            onOk={handleOk}
            onCancel={handleCancel}
            className="creatcourse"
        >
            <Search
                placeholder="视频名称"
                allowClear
                onSearch={onSearch}
                style={{ width: 304, marginBottom: 20 }}
            />
            <Table
                rowKey="id"
                loading={tableLoading}
                columns={columns}
                dataSource={VideoList}
                rowSelection={{
                    type: "radio",
                    onChange: onRadioChange,
                }}
                pagination={{
                    total: tableTotal,
                    onChange: (page) => {
                        getVideoList(page);
                    },
                    showTotal: (total) => {
                        return "共" + total + "条记录";
                    },
                }}
            />
        </Modal>
    )
}